// ===== Mueblika · Reseñas: carrusel + lightbox =====

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    initCarousel();
    initReviewLightbox();
  });

  /* ---------- Carrusel: desplaza de UNA en una, no por páginas ---------- */
  function initCarousel() {
    const track = document.querySelector('[data-mbk-resenas-track]');
    if (!track) return;

    const viewport = track.parentElement;
    const prevBtn = document.querySelector('[data-mbk-resenas-prev]');
    const nextBtn = document.querySelector('[data-mbk-resenas-next]');
    const cards = Array.from(track.children);
    if (!cards.length) return;

    let currentIndex = 0;

    function getStep() {
      // Ancho de una tarjeta + el gap entre ellas, medido de verdad
      // en el navegador (así se adapta solo a cada tamaño de pantalla)
      const cardRect = cards[0].getBoundingClientRect();
      const trackStyle = window.getComputedStyle(track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || 0);
      return cardRect.width + gap;
    }

    function getMaxIndex() {
      const step = getStep();
      const visibleCount = Math.round(viewport.clientWidth / step);
      return Math.max(0, cards.length - visibleCount);
    }

    function update() {
      const step = getStep();
      track.style.transform = 'translateX(' + (-currentIndex * step) + 'px)';

      const maxIndex = getMaxIndex();
      if (prevBtn) prevBtn.disabled = currentIndex <= 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        currentIndex = Math.max(0, currentIndex - 1);
        update();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        currentIndex = Math.min(getMaxIndex(), currentIndex + 1);
        update();
      });
    }

    window.addEventListener('resize', () => {
      currentIndex = Math.min(currentIndex, getMaxIndex());
      update();
    });

    update();
  }

  /* ---------- Lightbox de reseña completa ---------- */
  function initReviewLightbox() {
    const lightbox = document.querySelector('[data-mbk-review-lightbox]');
    if (!lightbox) return;

    const photoWrap = lightbox.querySelector('[data-mbk-review-photo-wrap]');
    const photo = lightbox.querySelector('[data-mbk-review-photo]');
    const stars = lightbox.querySelector('[data-mbk-review-stars]');
    const texto = lightbox.querySelector('[data-mbk-review-texto]');
    const nombre = lightbox.querySelector('[data-mbk-review-nombre]');
    const productoLink = lightbox.querySelector('[data-mbk-review-producto-link]');
    const closeBtns = lightbox.querySelectorAll('[data-mbk-review-close]');

    function open(trigger) {
      const foto = trigger.dataset.foto;
      if (foto) {
        photo.src = foto;
        photo.alt = trigger.dataset.nombre || '';
        photoWrap.hidden = false;
      } else {
        photoWrap.hidden = true;
      }

      const valoracion = parseInt(trigger.dataset.valoracion, 10) || 0;
      stars.innerHTML = '';
      for (let i = 1; i <= 5; i++) {
        const span = document.createElement('span');
        span.textContent = '★';
        if (i <= valoracion) span.classList.add('is-full');
        stars.appendChild(span);
      }

      texto.textContent = '"' + (trigger.dataset.texto || '') + '"';
      nombre.textContent = trigger.dataset.nombre || '';

      const productoUrl = trigger.dataset.productoUrl;
      if (productoUrl) {
        productoLink.href = productoUrl;
        productoLink.textContent = 'Ver ' + (trigger.dataset.productoNombre || 'producto') + ' →';
        productoLink.hidden = false;
      } else {
        productoLink.hidden = true;
      }

      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';

      // Guardamos qué botón en concreto lo abrió (hay uno distinto
      // por cada tarjeta de reseña) para devolverle el foco al cerrar.
      lastTrigger = trigger;
      const focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
    }

    function getFocusable() {
      return Array.from(
        lightbox.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetParent !== null);
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      if (lastTrigger) lastTrigger.focus();
    }

    let lastTrigger = null;

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-mbk-review-trigger]');
      if (trigger) {
        open(trigger);
        return;
      }
    });

    closeBtns.forEach((btn) => btn.addEventListener('click', close));

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key === 'Tab') {
        const focusable = getFocusable();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }
})();